import React from "react";
import { Loader2 } from "lucide-react";

/**
 * CTAButton — canonical primary/secondary/ghost button.
 * Pill-shaped on mobile, rectangular w/ tighter radius on desktop variant.
 */
const variants = {
    primary:
        "bg-md-primary text-md-primary-fg hover:opacity-90 active:scale-[0.98] disabled:opacity-50",
    secondary:
        "bg-md-secondary text-md-secondary-fg hover:opacity-90 active:scale-[0.98] disabled:opacity-50",
    outline:
        "bg-transparent border border-md-border text-md-text hover:bg-md-surface-2 disabled:opacity-50",
    ghost:
        "bg-transparent text-md-text hover:bg-md-surface-2 disabled:opacity-50",
    destructive:
        "bg-md-danger text-white hover:opacity-90 active:scale-[0.98] disabled:opacity-50",
    gold:
        "bg-md-secondary text-md-secondary-fg hover:opacity-90 active:scale-[0.98] disabled:opacity-50",
};

const sizes = {
    sm: "h-9 px-4 text-xs",
    md: "h-11 px-5 text-sm",
    lg: "h-13 px-7 text-base",
    block: "h-12 w-full text-sm",
};

export function CTAButton({
    variant = "primary",
    size = "md",
    icon = null,
    iconPosition = "left",
    loading = false,
    disabled = false,
    children,
    className = "",
    type = "button",
    testId,
    ...rest
}) {
    return (
        <button
            type={type}
            disabled={disabled || loading}
            data-testid={testId}
            className={`inline-flex items-center justify-center gap-2 rounded-full font-semibold tracking-wide transition-all ${
                variants[variant] || variants.primary
            } ${sizes[size] || sizes.md} ${className}`}
            {...rest}
        >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : icon && iconPosition === "left" ? icon : null}
            {children}
            {!loading && icon && iconPosition === "right" ? icon : null}
        </button>
    );
}

export default CTAButton;
